"use strict";

exports.__esModule = true;
exports.DeviceStateSubscription = DeviceStateSubscription;
exports.describeState = describeState;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _TimelineSubscription = require("../../Timeline/TimelineSubscription");
var _timelineDefinitions = require("../../Timeline/timelineDefinitions");
var _PlantStateActivitiesContext = require("../../PlantStateActivities/PlantStateActivitiesContext");
var _getEnabledPlantStateActivities = require("../../PlantStateActivities/getEnabledPlantStateActivities");
var _getPlantState = require("../../PlantStateActivities/getPlantState");
var _getPlantActivity = require("../../PlantStateActivities/getPlantActivity");
var _getPlantStateColor = require("../../PlantStateActivities/getPlantStateColor");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * Name the current classification: the state, and the activity when there is
 * one ("Unplanned downtime · Tool change").
 */
function describeState(plantStateActivities, value) {
  if (!value || !value.state) {
    return {
      stateName: null,
      activityName: null,
      text: null
    };
  }
  var enabled = plantStateActivities ? (0, _getEnabledPlantStateActivities.getEnabledPlantStateActivities)(plantStateActivities) : {};
  var state = (0, _getPlantState.getPlantState)(enabled.states || [], value.state);
  var activity = value.activity ? (0, _getPlantActivity.getPlantActivity)(enabled.activities || [], value.activity) : null;
  return {
    stateName: state.name,
    activityName: activity ? activity.name : null,
    text: activity ? state.name + " \xB7 " + activity.name : state.name
  };
}

/**
 * Follows a device's current classification and hands children its name,
 * colour and start time: `{ text, stateName, activityName, color, startMillis }`.
 */
function DeviceStateSubscription(_ref) {
  var deviceUuid = _ref.deviceUuid,
    children = _ref.children;
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext) || {};
  var plantStateActivities = (0, _react.useContext)(_PlantStateActivitiesContext.PlantStateActivitiesContext);
  return /*#__PURE__*/_react["default"].createElement(_TimelineSubscription.TimelineSubscription, {
    timelineName: _timelineDefinitions.TIME_SERIES_CLASSIFICATION,
    isCurrent: true,
    defaultValue: null,
    query: {
      device: deviceUuid
    }
  }, function (packet) {
    var value = packet && !(packet instanceof Error) ? packet.value : null;
    return children(Object.assign({}, describeState(plantStateActivities, value), {
      color: value ? (0, _getPlantStateColor.getPlantStateColor)(theme, value.state) : undefined,
      startMillis: packet && packet.interval ? packet.interval.startMillis : undefined
    }));
  });
}